import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from './axios/axios'
import { logout } from './userSlice'

const initialState = {
  riskfundList: [],
  riskfundPrintList: [],
  bankData: [],
  employeeData: [],
  error: null,
  isLoading: false,
  currentPage: 0,
  totalPages: 0,
  filter: '',
}

export const getRiskfundList = createAsyncThunk(
  'riskfund/getRiskfundList',
  async (obj, { rejectWithValue, fulfillWithValue, getState, dispatch }) => {
    try {
      const { user } = getState()

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.user.token}`,
        },
      }
      const res = await axios.get(`/api/home/riskfund?${obj}`, config)

      return fulfillWithValue(res.data)
    } catch (error) {
      if (error.response.status === 401 || error.response.status === 403) {
        dispatch(logout(error.response.data))
      }
      return rejectWithValue(error.response.data)
    }
  }
)

export const getRiskfundPrintList = createAsyncThunk(
  'riskfund/getRiskfundPrintList',
  async (obj, { rejectWithValue, fulfillWithValue, getState, dispatch }) => {
    try {
      const { user } = getState()

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.user.token}`,
        },
      }
      const res = await axios.get(`/api/print/printriskfunddata?${obj}`, config)

      return fulfillWithValue(res.data)
    } catch (error) {
      if (error.response.status === 401 || error.response.status === 403) {
        dispatch(logout(error.response.data))
      }
      return rejectWithValue(error.response.data)
    }
  }
)

const riskfundSlice = createSlice({
  name: 'riskfund',
  initialState,
  reducers: {
    resetState: (state) => {
      state.error = ''
      state.addSuccess = false
      state.updateSuccess = false
    },
  },
  extraReducers: {
    [getRiskfundList.pending]: (state) => {
      state.isLoading = true
      state.error = ''
    },
    [getRiskfundList.fulfilled]: (state, action) => {
      state.isLoading = false
      state.riskfundList = action.payload.items
      state.employeeData = action.payload.EmployeeData
      state.bankData = action.payload.BankData
      state.currentPage = action.payload.currentPage
      state.totalPages = action.payload.totalPages
    },
    [getRiskfundList.rejected]: (state, action) => {
      state.isLoading = false
      state.error = action.payload
    },

    [getRiskfundPrintList.fulfilled]: (state, action) => {
      state.isLoading = false
      state.riskfundPrintList = action.payload.items
      state.error = ''
      state.filter = action.payload.Filter
    },
    [getRiskfundPrintList.rejected]: (state, action) => {
      state.isLoading = false
      state.error = action.payload
    },
  },
})

export default riskfundSlice.reducer
